import React from "react";
import { toast } from "react-toastify";

export const showToast = (icon, message, params) =>
    toast(<span> &nbsp;{icon}&nbsp; {message || 'Internal exception (code JGG2YL)'} </span>, params);
